import React from "react";
import { BookOpen, ArrowUpRight } from "@phosphor-icons/react";
import { useBlogLinks } from "@/lib/useBlogLinks";

/**
 * Related-guides block for a service page.
 * Renders nothing if the given slug has no matching guides.
 */
export default function RelatedGuides({ slug }) {
  const blogLinks = useBlogLinks();
  const items = blogLinks.serviceRelated?.[`/${slug}`] || [];
  if (items.length === 0) return null;

  return (
    <section
      data-testid="related-guides"
      className="bg-white py-14 md:py-20 border-t border-zinc-100"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-blue-600">
          <BookOpen size={16} weight="duotone" />
          Related guides
        </div>
        <h2 className="mt-3 font-heading text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900">
          Read more from our TechConnect blog
        </h2>

        <ul className="mt-8 space-y-3">
          {items.map((g, i) => (
            <li key={g.url}>
              <a
                href={g.url}
                target="_blank"
                rel="noopener"
                data-testid={`related-guide-${i}`}
                className="group flex items-start gap-3 rounded-2xl border border-zinc-200 bg-white px-5 py-4 hover:border-blue-300 hover:bg-zinc-50 hover:shadow-sm transition-all"
              >
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-blue-600 shrink-0" />
                <span className="flex-1 text-zinc-800 font-medium">{g.label}</span>
                <ArrowUpRight
                  size={16}
                  weight="bold"
                  className="text-blue-600 shrink-0 mt-0.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
